import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import {
    onChangeCompetitorsParkingsChangesOperatorsFilter,
    onChangeCompetitorsParkingsChangesPeriod,
    onChangeCompetitorsParkingsChangesTypeFilter,
} from '../../../ac/onChangeMapFilters';
import { functionalAreasYandexUrentTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { DynamicAttributeFilter } from '../DynamicAttributeFilter';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const PERIOD_OPTIONS = [
    { value: 7, label: '7 дней' },
    { value: 14, label: '14 дней' },
    { value: 30, label: '30 дней' },
];
// Bolt в парковках не парсится; остальные операторы истории парковок есть
const OPERATORS_TYPES = functionalAreasYandexUrentTypes.filter(t => t.value !== 'Bolt');
const CompetitorsParkingsChangesComponent = ({
    mapFilters,
    onChangeCompetitorsParkingsChangesOperatorsFilter,
    onChangeCompetitorsParkingsChangesPeriod,
    onChangeCompetitorsParkingsChangesTypeFilter,
}) => {
    const {
        competitorsParkingsChangesPeriod,
        competitorsParkingsChangesAvailableOperators,
        competitorsParkingsChangesOperatorsDisabled,
        competitorsParkingsChangesDisabledTypes,
    } = mapFilters;
    const disabledTypes = competitorsParkingsChangesDisabledTypes || [];
    // Знак типа изменения: цвет обводки в легенде нейтральный (на карте он несёт
    // оператора), различие — форма: залитый / перечёркнутый / с точкой / полый кружок.
    // viewBox квадратный и кружок в его центре — сетка .checkboxIconGrid растягивает
    // svg до 10x10, и при несимметричном viewBox знаки уезжали относительно кружков
    // операторов. Перечёркивание нарочно выходит за кружок и толще его обводки:
    // в 10 пикселях иначе не читается.
    const renderSign = kind => (
        <svg
            viewBox="0 0 20 20"
            width="20"
            height="20"
            aria-hidden="true"
        >
            <circle
                cx="10"
                cy="10"
                r="6"
                fill={kind === 'new' ? '#ffffff' : 'none'}
                fillOpacity={kind === 'new' ? 0.95 : 0}
                stroke="#9ca3af"
                strokeWidth="2.5"
            />
            {kind === 'moved' && (
                <circle
                    cx="10"
                    cy="10"
                    r="2"
                    fill="#9ca3af"
                />
            )}
            {kind === 'presumed_deleted' && (
                <g
                    stroke="#ef4444"
                    strokeWidth="3"
                    strokeLinecap="round"
                >
                    <line
                        x1="2"
                        y1="2"
                        x2="18"
                        y2="18"
                    />
                    <line
                        x1="18"
                        y1="2"
                        x2="2"
                        y2="18"
                    />
                </g>
            )}
        </svg>
    );
    const renderTypeRow = (kind, id, label) => (
        <>
            {renderSign(kind)}
            <label htmlFor={id}>{label}</label>
            <div>
                <label className={styles.switch}>
                    <input
                        type="checkbox"
                        id={id}
                        name="competitorsParkingsChangesType"
                        value={kind}
                        checked={!disabledTypes.includes(kind)}
                        onChange={onChangeCompetitorsParkingsChangesTypeFilter}
                    />
                    <span className={classnames(styles.sliderRound, styles.slider)} />
                </label>
            </div>
        </>
    );

    return (
        <div>
            {/* Фильтр периода изменений */}
            <div className={styles.legHead}>{t`Период изменений`}:</div>
            <StandardRadioGroup
                value={competitorsParkingsChangesPeriod}
                onChange={onChangeCompetitorsParkingsChangesPeriod}
            >
                {PERIOD_OPTIONS.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={competitorsParkingsChangesPeriod === value}
                                onChange={onChangeCompetitorsParkingsChangesPeriod}
                                value={value}
                                className={classnames(styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: competitorsParkingsChangesPeriod === value,
                                })}
                                size="small"
                            />
                        }
                        label={label}
                        labelPlacement="end"
                    />
                ))}
            </StandardRadioGroup>

            {/* Фильтр операторов */}
            <DynamicAttributeFilter
                title={t`Операторы`}
                attributeTypes={OPERATORS_TYPES}
                availableValues={competitorsParkingsChangesAvailableOperators}
                disabledValues={competitorsParkingsChangesOperatorsDisabled}
                onToggle={onChangeCompetitorsParkingsChangesOperatorsFilter}
                inputNamePrefix="competitors-parkings-changes-operator"
            />

            {/* Типы изменений */}
            <div className={styles.legHead}>{t`Тип изменения`}:</div>
            <div className={styles.checkboxIconGrid}>
                {renderTypeRow('new', 'cpc-new', t`Новая парковка`)}
                {renderTypeRow('presumed_deleted', 'cpc-deleted', t`Предположительно удалена`)}
                {renderTypeRow('moved', 'cpc-moved', t`Парковка перемещена`)}
                {renderTypeRow('attrs_changed', 'cpc-attrs', t`Изменены атрибуты`)}
            </div>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(
    mapStateToProps,
    {
        onChangeCompetitorsParkingsChangesOperatorsFilter,
        onChangeCompetitorsParkingsChangesPeriod,
        onChangeCompetitorsParkingsChangesTypeFilter,
    }
)(CompetitorsParkingsChangesComponent);

export const CompetitorsParkingsChangesFilter = withDisplayedLayersCheck(
    ConnectedComponent,
    'Изменения парковок (конкуренты)'
);
